import React from "react";
import {
    Col,
    Container,
    Content,
    FlexboxGrid,
    Header,
    Navbar,
} from 'rsuite';
import { Icon } from '@rsuite/icons';
import { MainLogo } from "../utils/icons";
import image from "assets/img/full-screen-image-2.jpg";
import loader from "assets/img/init.svg";
require('assets/css/authLayout.css');

function InitView() {

    return (
        <div className="wrapper wrapper-full-page">
            <div className="full-page section-image" data-color="black">
                <Container>
                    <Header>
                        <Navbar appearance="subtle">
                            <Navbar.Brand href="https://wisesoft.com.ar" target="_blank">
                                <Icon as={MainLogo} style={{ fontSize: 36, marginRight: "5px", opacity: "0.5" }} />wiseSoft - Catálogo en línea
                            </Navbar.Brand>
                        </Navbar>
                    </Header>
                    <Content style={{ padding: "20px" }}>
                        <FlexboxGrid justify="center">
                            <FlexboxGrid.Item as={Col} colspan={24} md={5} style={{color:"#fff"}}>
                                <img src={loader} style={{ display: "block", margin: "auto", width: 150 }} alt="loading" />
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </Content>
                </Container>
                <div className="full-page-background" style={{ backgroundImage: `url(${image})` }}></div>
            </div>
        </div>
    );
}

export default InitView;